<mat-slide-toggle [formControl]="formControl"
                  labelPosition="before"
                  class="toggle">
    <span class="label">{{label}}</span>
</mat-slide-toggle>
<mat-error *ngIf="hasError"
           class="error-message">
    {{errorMessage}}
</mat-error>
